/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import MobiControlCore from '../../../v1/blocks/MobiControl/MobiControlCore';

function defineBlock(context) {
    let prop = {...context};
    prop.blockText = "request MC admin mode";
    prop.tooltipText = "Open the MobiControl admin password dialog.";
    prop.responseText = "result";
    prop.responseBlockType = "text_response";
    return MobiControlCore(prop);
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let coreResponseCode = block.getJavascriptCore();
            return `Snap.mcLockdown.requestAdminMode(${coreResponseCode});\n`;
        }
    }
}

const MobiControlRequestAdminMode = function (props) {
    const name = 'snap_mobicontrol_requestadminmode';
    MobiControlRequestAdminMode.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return <block type={name}></block>;
}

MobiControlRequestAdminMode.propTypes = {
    context: PropTypes.object
};

export default MobiControlRequestAdminMode;
